import { RTopicKnowledge } from '../remote/topicKnowledge';
import { TopicKnowledge } from '../domain/topicKnowledge';
import { mapTopic } from '../../Topic';

export const mapTopicKnowledge = (t: RTopicKnowledge): TopicKnowledge => ({
    topic: mapTopic(t.topic),
    knowledge: t.knowledge
});

export const mapTopicKnowledges = (topics: RTopicKnowledge[] | null): TopicKnowledge[] =>
    topics?.map(mapTopicKnowledge) ?? [];
